import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const RightNavigationArrow: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      className={UNSAFE_className || ''}
      {...props}
      height={IconHeight[size]}
      data-testid={`Right navigation arrow`}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Live area">
        <path
          d="M18.6463 12.7898H3.24051C3.02801 12.7898 2.84984 12.718 2.70601 12.5743C2.56234 12.4305 2.49051 12.2522 2.49051 12.0395C2.49051 11.827 2.56234 11.649 2.70601 11.5053C2.84984 11.3618 3.02801 11.29 3.24051 11.29H18.6463L14.3095 6.93803C14.1733 6.8012 14.1021 6.63012 14.0958 6.42478C14.0896 6.21945 14.1608 6.04187 14.3095 5.89203C14.4458 5.7547 14.6193 5.68604 14.83 5.68604C15.0408 5.68604 15.2154 5.75529 15.3538 5.89379L20.8673 11.4073C20.9609 11.5008 21.0269 11.6 21.0653 11.7048C21.1038 11.8095 21.123 11.9216 21.123 12.0413C21.123 12.161 21.1037 12.2746 21.065 12.3823C21.0262 12.49 20.9603 12.59 20.8673 12.6823L15.3538 18.1958C15.2169 18.3341 15.0458 18.4033 14.8405 18.4033C14.6353 18.4033 14.4583 18.3341 14.3095 18.1958C14.1545 18.047 14.0786 17.8687 14.0818 17.661C14.0849 17.4534 14.1608 17.2752 14.3095 17.1265L18.6463 12.7898Z"
          fill="#1F1F1F"
        />
      </g>
    </svg>
  );
};

export default RightNavigationArrow;
